<template>
  <USlideover
    side="left"
    close-icon="i-lucide-arrow-right"
    :ui="{ body: 'p-0 sm:py-0' }"
  >
    <UChip class="lg:hidden" color="error" :show="unreadMessages" inset>
      <UButton
        icon="i-heroicons-bars-3-16-solid"
        :aria-label="t('accessibility.menuOpen')"
        color="neutral"
        variant="ghost"
        size="md"
        :ui="{ base: 'p-0', leadingIcon: 'size-7' }"
      />
    </UChip>

    <template #header="{ close }">
      <div class="flex items-center justify-between w-full">
        <span class="lg:hidden" aria-hidden="true">
          <img
            src="~/assets/img/logo-header.png"
            width="149"
            height="26"
            alt="EscapadaRural"
          />
        </span>

        <UButton
          icon="i-heroicons-x-mark"
          :aria-label="t('accessibility.menuClose')"
          color="neutral"
          variant="ghost"
          size="xl"
          :chip="true"
          @click="close"
        />
      </div>
    </template>

    <template #body>
      <ClientOnly>
        <div>
          <MenuPublicVertical />
          <MenuPrivate :show-separator="true" />
          <TSeparator classes="my-4" color-classes="border-gray-300" />
          <AuthHeader />
          <MenuUser />
        </div>
      </ClientOnly>
    </template>
  </USlideover>
</template>

<script setup lang="ts">
import { useLoginComposable } from '~~/modules/auth/composables/useLoginComposable'

const { RenderAuthUserInstance } = useLoginComposable()

const unreadMessages = computed(() => {
  return RenderAuthUserInstance?.value?.show_unread ? true : false
})
</script>
